<template>
    <v-row align="center" class="row--small font-size-14">
        <v-col cols="3" md="2">
            {{ label }}
        </v-col>
        <v-col cols="9" md="10">
            <slot />
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        label: String,
    }
}
</script>